import { takeLatest } from 'redux-saga/effects';
import {
  getAnnouncementListSuccess, getAnnouncementListFail,
  getAnnouncementDetailsSuccess, getAnnouncementDetailsFail
} from './announcementState';
import createCrudService from '../../services/crudservice';
import { 
  doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
  createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/system/announcements');
const redirectData = { route:'/console/announcements', mode:'list', recordId:0 };
const modelName = 'Announcement';
const modelId = 'ann_id';

function* getAnnouncementList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getAnnouncementListSuccess,
    getAnnouncementListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getAnnouncementDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getAnnouncementDetailsSuccess,
    getAnnouncementDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doAnnouncementCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getAnnouncementDetailsSuccess,
    getAnnouncementDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    SAVING_MSG
  );
}

function* doAnnouncementUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(data.payload[modelId], data.payload),
    getAnnouncementDetailsSuccess,
    getAnnouncementDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    UPDATING_MSG
  );
}

function* doAnnouncementDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getAnnouncementDetailsSuccess,
    getAnnouncementDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode:data.payload.mode },
    DELETING_MSG
  );
}

function* announcementSaga() {
  yield takeLatest('announcement/getAnnouncementList', getAnnouncementList);
  yield takeLatest('announcement/getAnnouncementDetails', getAnnouncementDetails);
  yield takeLatest('announcement/doAnnouncementCreate', doAnnouncementCreate);
  yield takeLatest('announcement/doAnnouncementUpdate', doAnnouncementUpdate);
  yield takeLatest('announcement/doAnnouncementDelete', doAnnouncementDelete);
}

export default announcementSaga;
